import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { SxProps, Typography, useTheme } from '@mui/material'
import React from 'react'

interface Props {
  textKey?: string
  sx?: SxProps
}

const DEFAULT_KEY = 'new-content.label'

/**
 * Label indicating that a page includes new content
 */
const NewLabel: React.FC<Props> = ({ textKey = DEFAULT_KEY, sx }) => {
  const { t } = useCustomTranslation()
  const title = t(textKey)
  const theme = useTheme()

  return (
    <Typography
      variant="body2"
      sx={{
        fontSize: '11px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&&': {
          color: theme.palette.primary.main,
        },
      }}
    >
      {title}
    </Typography>
  )
}

export default NewLabel
